import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, combinedSettingsSelector, makeTextStyleSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { getAggregate } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector, makeReloadHashSelector } from "./selectors";
import { type Kpi } from "./types";

type Settings = {
  kpi: Kpi.Api.KpiType | null;
  beforeText: string;
  afterText: string;
};
const makeMapStateToProps = () => {
  const reloadHashSelector = makeReloadHashSelector();
  const settingsSelector = combinedSettingsSelector<Settings>(TargetSelector.Entity, [
    "kpi",
    "beforeText",
    "afterText"
  ]);
  const textStyleSelector = makeTextStyleSelector(TargetSelector.Entity);

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      ...settingsSelector(state, props),
      aggregateValue: localState.aggregateValue,
      error: localState.error,
      isEditMode: state.isEditMode,
      reloadHash: reloadHashSelector(state, props),

      status: localState.status,
      textStyle: textStyleSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  getAggregate: () => dispatch(getAggregate({ id: props.id, source: props.source }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
